import BookingStatusCell from './BookingStatusCell';

export default BookingStatusCell;
